export default "__VITE_ASSET__BTHEwRTX__"